/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EmploymentStatus {
  ELIGIBLE_EMPLOYED = 'ELIGIBLE_EMPLOYED',
  ELIGIBLE_UPCOMING_LEAVE = 'ELIGIBLE_UPCOMING_LEAVE',
  INELIGIBLE_WAITING = 'INELIGIBLE_WAITING',
  INELIGIBLE_ON_LEAVE = 'INELIGIBLE_ON_LEAVE',
  ELIGIBLE_ENDING = 'ELIGIBLE_ENDING',
  INELIGIBLE_TERMINATED = 'INELIGIBLE_TERMINATED',
  INELIGIBLE = 'INELIGIBLE',
}
